define('blocks/header/header',['require'],function (require) {
  (function(){
    var $headerFix = $('[data-block="header-fix"]'),
        $header = $('[data-block="header"]'),
        $window = $(window)
    ;

    function fixTop() {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        var offsetTop = $header.offset().top;

        if ($window.scrollTop() > offsetTop) {
          $headerFix.addClass('-view');
        } else {
          $headerFix.removeClass('-view');
        }
      }
    }

    fixTop();

    $window.scroll(fixTop);

  })();
});

